import { render, staticRenderFns } from "./TemplateSummaryView.vue?vue&type=template&id=2a23c084&"
import script from "./TemplateSummaryView.vue?vue&type=script&lang=ts&"
export * from "./TemplateSummaryView.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateSummaryView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports